:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  display: inline-block;
  width: auto;
  cursor: pointer;
}

.dc-ui-btn {
  align-content: center;
  align-items: center;
  border: none;
  cursor: inherit;
  display: inline-flex;
  gap: 7px;
  justify-content: center;
  outline: 0;
  padding: 0;
  position: relative;
  text-transform: uppercase;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  background-size: 300% 300%;
  background-position: 0 0;
  animation: animation-out 350ms forwards;
}
.dc-ui-btn > span {
  font-family: "Bosch sans";
}
.dc-ui-btn.disabled, .dc-ui-btn[disabled] {
  cursor: not-allowed;
}
.dc-ui-btn:focus-visible:not(.disabled):not([disabled]):before {
  content: "";
  position: absolute;
  inset: 0;
  border: 2px solid #009cc2;
  z-index: 3;
}
.dc-ui-btn:focus-visible:not(.disabled):not([disabled]):after {
  content: "";
  position: absolute;
  inset: 2px;
  border: 1px solid #ffffff;
  z-index: 3;
}
.dc-ui-btn--align-left {
  justify-content: flex-start;
}
.dc-ui-btn--align-right {
  justify-content: flex-end;
}
.dc-ui-btn--primary {
  background-color: #ed0007;
  color: #ffffff;
  background-image: linear-gradient(-4deg, transparent 33%, #d50005 34%, #d50005 66%, transparent 67%);
}
.dc-ui-btn--primary:active:not(.disabled):not([disabled]) {
  background-image: none;
  background-color: #a80003;
}
.dc-ui-btn--primary.disabled, .dc-ui-btn--primary[disabled] {
  background-color: #cad6dd;
  color: #a3bac8;
}
.dc-ui-btn--secondary {
  background-color: #00c8f7;
  color: #002936;
  background-image: linear-gradient(-4deg, transparent 33%, #00b9e5 34%, #00b9e5 66%, transparent 67%);
}
.dc-ui-btn--secondary:active:not(.disabled):not([disabled]) {
  background-image: none;
  background-color: #009cc2;
}
.dc-ui-btn--secondary.disabled, .dc-ui-btn--secondary[disabled] {
  background-color: #cad6dd;
  color: #a3bac8;
}
.dc-ui-btn--tertiary {
  background-color: #506e81;
  color: #ffffff;
  background-image: linear-gradient(-4deg, transparent 33%, #476273 34%, #476273 66%, transparent 67%);
}
.dc-ui-btn--tertiary:active:not(.disabled):not([disabled]) {
  background-image: none;
  background-color: #354956;
}
.dc-ui-btn--tertiary.disabled, .dc-ui-btn--tertiary[disabled] {
  background-color: #cad6dd;
  color: #a3bac8;
}
.dc-ui-btn--light {
  background-color: #a3bac8;
  color: #002b49;
  background-image: linear-gradient(-4deg, transparent 33%, #99aebb 34%, #99aebb 66%, transparent 67%);
}
.dc-ui-btn--light:hover, .dc-ui-btn--light:focus, .dc-ui-btn--light:active {
  color: #000000;
}
.dc-ui-btn--light:active:not(.disabled):not([disabled]) {
  background-image: none;
  background-color: #7995a6;
}
.dc-ui-btn--light.disabled, .dc-ui-btn--light[disabled] {
  background-color: #cad6dd;
  color: #a3bac8;
}
.dc-ui-btn--link {
  background-color: transparent;
  color: #506e81;
  background-image: linear-gradient(-4deg, transparent 33%, #edf1f4 34%, #edf1f4 66%, transparent 67%);
}
.dc-ui-btn--link:hover, .dc-ui-btn--link:focus, .dc-ui-btn--link:active {
  color: #1c272e;
}
.dc-ui-btn--link:active:not(.disabled):not([disabled]) {
  background-image: none;
  background-color: #cad6dd;
}
.dc-ui-btn--link.disabled, .dc-ui-btn--link[disabled] {
  background-color: transparent;
  color: #a3bac8;
}
.dc-ui-btn--small {
  height: 32px;
  padding: 0 15px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 900;
}
.dc-ui-btn--small.dc-ui-btn--icon:not(.dc-ui-btn--hide-label) {
  padding: 0 15px 0 16px;
}
.dc-ui-btn--small.dc-ui-btn--hide-label {
  padding: 0 6px;
}
.dc-ui-btn--normal {
  height: 48px;
  padding: 0 15px;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 900;
}
.dc-ui-btn--normal.dc-ui-btn--icon:not(.dc-ui-btn--hide-label) {
  padding: 0 15px 0 16px;
}
.dc-ui-btn--normal.dc-ui-btn--hide-label {
  padding: 0 12px;
}
.dc-ui-btn--large {
  height: 54px;
  padding: 0 15px;
  font-size: 1.25rem;
  line-height: 1.375rem;
  font-weight: 900;
}
.dc-ui-btn--large.dc-ui-btn--icon:not(.dc-ui-btn--hide-label) {
  padding: 0 15px 0 16px;
}
.dc-ui-btn--large.dc-ui-btn--hide-label {
  padding: 0 11px;
}
.dc-ui-btn--hide-label {
  gap: 0;
}
.dc-ui-btn--hide-label > span {
  display: block;
  width: 1px;
  -webkit-text-size-adjust: none;
     -moz-text-size-adjust: none;
          text-size-adjust: none;
  height: 1px;
  margin: 0px 0px 0px -1px;
  overflow: hidden;
}
.dc-ui-btn:hover:not(.disabled):not([disabled]) {
  animation: animation-in 350ms forwards;
}

@keyframes animation-out {
  from {
    z-index: inherit;
    background-position: 50% 50%;
  }
  to {
    background-position: 100% 100%;
  }
}
@keyframes animation-in {
  from {
    z-index: inherit;
    background-position: 0 0;
  }
  to {
    z-index: inherit;
    background-position: 50% 50%;
  }
}